import React from "react";
import { useFormatProduct } from "@app/hooks/use-format-product";
import { Price } from "./price";
import { Badge } from "./badge";
import { ProductSwatch, CardProductSwatches } from "./swatches";
import { useSearchspringProductSearch } from "@app/hooks/use-searchspring-product-search";

type Props = Parameters<typeof useFormatProduct>[0];

export function CardProduct({ data, source }: Props) {
  const { updateHandle, currentResult } = useSearchspringProductSearch(data);
  const product = useFormatProduct({ data: currentResult, source });

  const swatchesSorted =
    product?.swatches?.sort((a: ProductSwatch, b: ProductSwatch) => {
      if (a.handle === data.handle) return -1;
      if (b.handle === data.handle) return 1;
      return 0;
    }) ?? [];

  return (
    <div className="flex h-full flex-col justify-between">
      <a href={product.url} className="relative aspect-4/5">
        <div className="group absolute inset-0 h-full w-full overflow-hidden rounded rounded-b-none">
          <img src={product.imageUrl} alt={product.name} className="block h-full w-full object-cover" />
        </div>
        {product.images.secondaryImage && (
          <div className="group absolute inset-0 h-full w-full overflow-hidden rounded rounded-b-none">
            <img
              src={product.images.secondaryImage}
              alt={product.name}
              className="block h-full w-full object-cover opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            />
          </div>
        )}
        <div className="absolute bottom-2 left-2">
          <Badge
            criteria={{
              tags: product.tags,
              productIds: [product.id],
              collectionIds: product?.collectionId ?? [],
            }}
            showTooltip={false}
          />
        </div>
      </a>
      <div className="flex h-full flex-col gap-3 rounded-b bg-neutrals-white p-4 pb-5">
        <div className="flex flex-col gap-1">
          <a href={product.url} className="text-body-md min-h-min font-normal hover:underline hover:underline-offset-2">
            {product.name}
          </a>
          <div className="text-body-sm">
            <Price
              values={{
                price: product.price * 100,
                compareAtPrice: product.compareAtPrice * 100,
                membersPrice: product.membersPrice * 100,
              }}
            />
          </div>
        </div>
        <CardProductSwatches
          resultHandle={currentResult.handle}
          swatches={swatchesSorted}
          updateSwatch={updateHandle}
        />
      </div>
    </div>
  );
}
